function device() {
    var ua = window.navigator.userAgent.toLocaleLowerCase();
    var isIOS = /iphone|ipad|ipod/.test(ua);
    var isAndroid = /android/.test(ua);
    var isMiuiBrowser = /miuibrowser/.test(ua);
    var isSafari = /Safari/i.test(ua) && !/Chrome/i.test(ua);
    var isWxBrowser = /micromessenger/.test(navigator.userAgent.toLowerCase());
    var isAPP = window.location.href.indexOf('source=app') !== -1;
    var isMinip=ua.indexOf('micromessenger') != -1 || ua.indexOf('miniProgram') != -1 || ua.indexOf('toutiao') != -1
    // var isTT = window.location.href.indexOf('platform=tt') !== -1;
    var source = getUrlKeyWord('source') || 'other'
    return {
        isIOS: isIOS,
        isAndroid: isAndroid,
        isMiuiBrowser,
        isSafari,
        isWxBrowser,
        isAPP,
        isIOSWxMini: isIOS && !isAPP,
        isMinip,//是否是小程序
        source
    };
}

export function getUrlKeyWord(keyWord: string) {
    let keyAfter = location.href.split(`${keyWord}=`)[1]
    let value = ''
    if (keyAfter) {
      value = keyAfter.split('&')[0]
    }
    return value
}

export const judgeDeviceType = device();

function activeElementScrollIntoView(activeElement: HTMLElement, delay: number, scrollOption: boolean) {
    var editable = activeElement.getAttribute('contenteditable');

    // 输入框、textarea或富文本获取焦点后没有将该元素滚动到可视区
    if (activeElement.tagName == 'INPUT' || activeElement.tagName == 'TEXTAREA' || editable === '' || editable) {
        setTimeout(function () {
            activeElement.scrollIntoView(scrollOption);
        }, delay);
    }
}

export function listenKeybord($input: HTMLElement, $container: HTMLElement) {
    if (judgeDeviceType.isIOS) {
        const rect = $container.getBoundingClientRect();
        // IOS 键盘弹起：IOS 和 Android 输入框获取焦点键盘弹起
        $input.addEventListener('focus', function () {
            let virtualHeight = virtualKeyboardHeight();
            window.scrollTo(0, document.body.scrollHeight);
            // console.log('virtualHeight: ', virtualHeight, visualViewport.height)
            // $container.style.height = 100 + 'px'
            // console.log('focus ios innerHeight:', $container.style.height)
            // Safari 浏览器，`scrollIntoView` 参数设为 `false`，才使得聊天输入框刚好吸附在输入法上，为 `true` 会往上走一点
            activeElementScrollIntoView(this, 50, !judgeDeviceType.isSafari);
        }, false);

        // IOS 键盘收起：IOS 点击输入框以外区域或点击收起按钮，输入框都会失去焦点，键盘会收起，
        $input.addEventListener('blur', () => {
            // 微信浏览器版本6.7.4+IOS12会出现键盘收起后，视图被顶上去了没有下来
            console.log('blur ios innerHeight:', window.innerHeight);
            // $container.style.height = rect.height + 'px'
            var wechatInfo = window.navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i);
            if (!wechatInfo) return;

            var wechatVersion = wechatInfo[1];
            var version = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);

            if (+wechatVersion.replace(/\./g, '') >= 674 && +version[1] >= 12) {
                setTimeout(function () {
                    window.scrollTo(0, Math.max(document.body.clientHeight, document.documentElement.clientHeight));
                });
            }
        });
    }

    if (judgeDeviceType.isAndroid) {
        var originHeight = document.documentElement.clientHeight || document.body.clientHeight;

        window.addEventListener('resize', function () {
            var resizeHeight = document.documentElement.clientHeight || document.body.clientHeight;
            if (originHeight < resizeHeight) {
                // 修复小米浏览器下，输入框依旧被输入法遮挡问题
                if (judgeDeviceType.isMiuiBrowser) {
                    document.body.style.marginBottom = '0px';
                }
            } else {
                // 修复小米浏览器下，输入框依旧被输入法遮挡问题
                if (judgeDeviceType.isMiuiBrowser) {
                    document.body.style.marginBottom = '40px';
                }
                activeElementScrollIntoView($input, 1000, true);
            }

            originHeight = resizeHeight;
        }, false);
    }
}


const virtualKeyboardHeight = function () {
    var sx = document.body.scrollLeft, sy = document.body.scrollTop;
    var naturalHeight = window.innerHeight;
    console.log('virtualKeyboardHeight:', sx, sy, naturalHeight, document.body.scrollHeight);
    window.scrollTo(sx, document.body.scrollHeight);
    var keyboardHeight = naturalHeight - window.innerHeight;
    window.scrollTo(sx, sy);
    return keyboardHeight;
};

export function getKeyCode(str: string) {
    return str.charCodeAt(str.length);
}

export const IS_INPUT_SUPPORTED = (function () {
    try {
        // just kill browsers off, that throw an error if they don't know
        // `InputEvent`
        const event = new InputEvent('input', {
            data: 'xyz',
            inputType: 'deleteContentForward'
        });
        let support = false;

        // catch the others
        // https://github.com/chromium/chromium/blob/c029168ba251a240b0ec91fa3b4af4214fbbe9ab/third_party/blink/renderer/core/events/input_event.cc#L78-L82
        const el = document.createElement('input');
        el.addEventListener('input', function (e: InputEvent) {
            if (e.inputType === 'deleteContentForward') {
                support = true;
            }
        });

        el.dispatchEvent(event);
        return support;
    } catch (error) {
        return false;
    }
})();

export interface CompatibleInputEvent {
    data?: string;
    inputType?: string;
    navigationType?: string;
    originalEvent: KeyboardEvent | InputEvent;
}

export const normalizeInputEvent = function (event: KeyboardEvent | InputEvent): CompatibleInputEvent {
    const e: CompatibleInputEvent = {
        originalEvent: event
    };

    if (event instanceof KeyboardEvent) {
        if (event.key === 'Backspace') {
            e.inputType = 'deleteContentBackward';
            e.navigationType = 'cursorLeft';
        } else if (event.key === 'Delete') {
            e.inputType = 'deleteContentForward';
        } else if (event.key.startsWith('Arrow')) {
            e.navigationType = event.key.replace('Arrow', 'cursor');
        } else {
            e.data = event.key;
            e.inputType = 'insertText';
        }
    } else {
        // @ts-ignore event.inputType is there on android - actually what we need here!
        const { inputType } = event;
        e.inputType = inputType;
        e.data = event.data;

        if (inputType === 'insertText') {
            e.navigationType = 'cursorRight';
        }
    }

    return e;
};
